import { CopyIconButton } from '@components/button';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { useTheme } from '@mui/material';
import type { CSSProperties } from 'react';

interface DatasetsDetailsInfoPreviewProps {
  display?: string;
  name: string;
  noCopy?: boolean;
  title?: string;
  value: string | number;
  onClick?: (event) => void;
  nameStyle?: CSSProperties;
}

export const DatasetsDetailsInfoPreview = ({
  display,
  name,
  noCopy = false,
  title,
  value,
  nameStyle,
  onClick,
}: DatasetsDetailsInfoPreviewProps) => {
  const { palette } = useTheme();
  return (
    <Group alignItems="center" justifyContent="space-between" height="28px">
      <Typography variant="caption2" color={palette.text.paper} sx={nameStyle}>
        {name}
      </Typography>
      <Group
        alignItems="center"
        gap={1}
        sx={{ mr: noCopy || value === undefined || value === null ? 0 : '-8px' }}
      >
        {value === undefined || value === null ? (
          <Typography variant="caption2" color={palette.text.contrast}>
            -
          </Typography>
        ) : (
          <Typography
            variant="caption2"
            color={palette.text.contrast}
            sx={{
              cursor: onClick && 'pointer',
              textDecoration: onClick && 'underline',
            }}
            onClick={onClick}
            tooltip={(onClick && title) || ''}
            tooltipProps={{ variant: 'secondary' }}
            handleOverFlow
          >
            {display ?? value}
          </Typography>
        )}
        {value !== undefined && value !== null && !noCopy ? (
          <CopyIconButton value={value} tooltipProps={{ variant: 'secondary' }} />
        ) : null}
      </Group>
    </Group>
  );
};
